import './App.css';

import Comments from './components/comments';

function App() {
	return (
		<section className="bg-background font-Rubik">
			<h2 className="hidden">Section Heading</h2>
			<Comments />
		</section>
	);
}

export default App;
